import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@anytag/shared-utils';

interface CampaignTotalProps {
  count?: number;
  unit?: ReactNode;
  className?: string;
  title?: ReactNode;
}

export const CampaignTotal = ({ count, unit, className, title }: CampaignTotalProps) => {
  const { t } = useTranslation();

  return (
    <div className={cn('total-cell flex items-center justify-between', className)}>
      <div className="text-base">{title || t('HeaderColumn.Total')}</div>
      {count ? (
        <div className="text-base whitespace-nowrap">
          {count}
          {unit ? (
            <>
              &nbsp;
              <span className="text-xxs font-normal uppercase">{unit}</span>
            </>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};
